<!-- features/dashboard/page/dashboard/dashboard.html -->

<div class="dashboard-page" [class.dashboard-page--embed]="isConfigured">
  @if (isConfigured) {
    <div
      #supersetContainer
      class="dashboard-page__superset-container"
      [hidden]="embedFailed"
    ></div>

    @if (embedFailed) {
      <p class="dashboard-page__placeholder">
        {{ 'dashboard.embedError' | translate }}
      </p>
    }
  } @else {
    <p class="dashboard-page__placeholder">
      {{ 'dashboard.comingSoon' | translate }}
    </p>
  }
</div>
